<template>
  <el-container class="home-container">
    <!--头部布局-->
    <el-header>
      <div class="header-left">
        <img src="@/assets/logo.png" class="logo_img" />
        <span class="title">EvaJudge</span>
      </div>

      <div class="navbar_user">
        <i class="iconfont icon-quanping" title="Fullscreen" @click="screenfull"></i>

        <el-dropdown @command="changeValue1">
          <span><i class="iconfont icon-duiwu"></i></span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item) in option1"
              :key="item.value"
              :command="item.label"
            >
              {{ item.label }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>

    <el-container>
      <!--侧边栏-->
      <el-aside :width="isCollapse ? '64px' : '200px'">
        <div class="toggle-button" @click="toggleCollapase">
          {{ isCollapse ? '>' : '<' }}
        </div>

        <el-menu
          :collapse="isCollapse"
          :router="true"
          :default-active="activePath"
          unique-opened
        >
          <el-menu-item index="/welcome" @click="saveNavState('/welcome')">
            <i class="iconfont icon-shouye"></i>
            <span>Index</span>
          </el-menu-item>

          <el-menu-item index="/dataset" @click="saveNavState('/dataset')">
            <i class="iconfont icon-shujuku"></i>
            <span>Benchmarks</span>
          </el-menu-item>

          <el-menu-item index="/assess" @click="saveNavState('/assess')">
            <i class="iconfont icon-zaixianceping"></i>
            <span>Submit</span>
          </el-menu-item>

          <el-menu-item index="/showmetric" @click="saveNavState('/showmetric')">
            <i class="iconfont icon-liuliangtongji"></i>
            <span>Leaderboard</span>
          </el-menu-item>

          <el-menu-item index="/progress" @click="saveNavState('/progress')">
            <i class="iconfont icon-icon_renwujincheng"></i>
            <span>Status</span>
          </el-menu-item>

          <el-submenu
            v-for="item in visibleMenuList"
            :key="item.id"
            :index="item.id + ''"
          >
            <template slot="title">
              <i :class="iconsObject[item.id]"></i>
              <span>{{ item.title }}</span>
            </template>

            <el-menu-item
              v-for="it in item.sList"
              :key="it.id"
              :index="it.path"
              @click="saveNavState(it.path)"
            >
              <i :class="iconsObject[it.id]"></i>
              <span>{{ it.title }}</span>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>

      <!--主体-->
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import screenfull from "screenfull";

export default {
  data() {
    return {
      isCollapse: false,
      activePath: "/welcome",
      isAdmin: false,

      menuList: [
        {
          id: "100",
          title: "Account",
          sList: [
            { id: "101", title: "User Management", path: "/userlist" },
            { id: "102", title: "Analytics", path: "/ana" },
          ],
        },
      ],

      iconsObject: {
        "100": "iconfont icon-zhanghaoquanxianguanli",
        "101": "iconfont icon-yonghuliebiao",
        "102": "iconfont icon-liuliangtongji",
      },

      option1: [
        { label: "Logout", value: 0 }
      ],
    };
  },

  created() {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (user) {
      this.isAdmin = Number(user.Level) === 1;
    }

    this.activePath =
      window.sessionStorage.getItem("activePath") || "/welcome";
  },

  computed: {
    visibleMenuList() {
      return this.menuList.filter((item) => {
        if (item.id === "100") return this.isAdmin;
        return true;
      });
    },
  },

  methods: {
    toggleCollapase() {
      this.isCollapse = !this.isCollapse;
    },

    saveNavState(path) {
      window.sessionStorage.setItem("activePath", path);
      this.activePath = path;
    },

    changeValue1(text) {
      if (text === "Logout") {
        sessionStorage.clear();
        this.$router.push("/login");
      } else {
        this.$router.push("/edituser");
      }
    },

    screenfull() {
      screenfull.toggle();
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  height: 100%;
}

/* ===== Header ===== */
.el-header {
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.header-left {
  display: flex;
  align-items: center;
}

.logo_img {
  height: 36px;
}

.title {
  margin-left: 12px;
  font-size: 18px;
  font-weight: 600;
  color: #1f2a44;
}

/* ===== Sidebar ===== */
.el-aside {
  background: #fafbfc;
  border-right: 1px solid #e5e7eb;
}

/* ===== Menu ===== */
.el-menu {
  background: transparent !important;
  border-right: none;
}

.el-menu-item {
  color: #374151 !important;
}

.el-menu-item:hover {
  background: #f3f4f6 !important;
}

.el-menu-item.is-active {
  color: #1f2a44 !important;
  background: linear-gradient(
    90deg,
    rgba(63, 174, 154, 0.12),
    rgba(111, 209, 194, 0.12)
  );
  border-radius: 6px;
}

/* ===== Icon ===== */
.iconfont {
  margin-right: 10px;
  color: #6b7280;
}

.el-menu-item.is-active .iconfont {
  color: #3fae9a;
}

/* ===== Toggle ===== */
.toggle-button {
  text-align: center;
  padding: 8px;
  cursor: pointer;
  color: #9ca3af;
}

.toggle-button:hover {
  color: #1f2a44;
}

/* ===== Main ===== */
.el-main {
  background: #ffffff;
}
</style>